var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlackcopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 39,
    viewBox: "0 0 30 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2497 0L20.0895 0.0109524L20.5049 0.0122573L29.1621 8.77004V28.3515C29.1621 29.9394 27.8677 31.2265 26.2709 31.2265H8.92431C7.3276 31.2265 6.0332 29.9394 6.0332 28.3515V2.88726C6.0332 1.29944 7.3276 0.0122573 8.92431 0.0122573L19.2483 0.0109524L19.2497 0ZM19.2483 1.6543L8.92427 1.6556C8.23996 1.6556 7.68522 2.20725 7.68522 2.88774V28.352C7.68522 29.0325 8.23996 29.5842 8.92427 29.5842H26.2709C26.9552 29.5842 27.51 29.0325 27.51 28.352V9.92471L22.1408 9.86989C20.544 9.86989 19.2497 8.58271 19.2497 6.99489L19.2483 1.6543ZM20.9024 6.99119V2.75391L26.3528 8.26711L22.1501 8.22338C21.4572 8.22333 20.9024 7.67168 20.9024 6.99119Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2165 7L14.0563 7.01095L14.4717 7.01226L23.1289 15.77V35.3515C23.1289 36.9394 21.8345 38.2265 20.2377 38.2265H2.89111C1.29439 38.2265 0 36.9394 0 35.3515V9.88726C0 8.29944 1.29439 7.01226 2.89111 7.01226L13.2151 7.01095L13.2165 7ZM13.2147 8.6543L2.89066 8.6556C2.20635 8.6556 1.65161 9.20725 1.65161 9.88774V35.352C1.65161 36.0325 2.20635 36.5842 2.89066 36.5842H20.2373C20.9216 36.5842 21.4763 36.0325 21.4763 35.352V16.9247L16.1071 16.8699C14.5104 16.8699 13.216 15.5827 13.216 13.9949L13.2147 8.6543ZM14.8688 13.9912V9.75391L20.3192 15.2671L16.1165 15.2234C15.4235 15.2233 14.8688 14.6717 14.8688 13.9912Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackcopy);
export default __webpack_public_path__ + "static/media/blackcopy.35037c80e28792ef923d34b10f840d20.svg";
export { ForwardRef as ReactComponent };